<template>
  <div v-show="show" class="mx-8">
    <v-snackbar
      v-model="snackbar"
      :min-width="0"
      color="#f8f3d6"
      top
      timeout="2000"
    >
      <span class="black--text">{{ notimsg }}</span>
    </v-snackbar>
    <v-card 
      v-if="isOneTime"
      flat 
      class="rounded-lg py-10 px-10" 
      width="100%"
      style="margin-left: auto; margin-right: auto; max-width: fit-content;"
    >
      <div class="d-flex justify-center mt-3">
        <v-icon x-large color="#D69120">question_answer</v-icon>
      </div>
      <v-card-title class="d-flex justify-center pt-1">
        <span style="font-size: 20px;">บัญชี "{{usernameOneID ? usernameOneID : 'Unknown User'}}"</span>
      </v-card-title>
      <v-card-subtitle class="d-flex justify-center pt-1">
        <span style="font-size: 20px;">ได้ทำแบบสอบถามนี้ไปแล้ว</span>
      </v-card-subtitle>
    </v-card>
    <v-card
      v-else
      flat
      :color="wc_color"
      class="rounded-lg pb-6"
      style="margin-left: auto; margin-right: auto"
      :width="widthCard"
    >
      <v-card-title v-if="image" class="justify-center px-4">
        <v-img
          v-if="image_size === '100%'"
          :src="image_url"
          width="100"
          height="auto"
        ></v-img>
        <img v-else :src="image_url" :width="TabletSize || mobile_mode ? '100%' : image_size+'%'" />
        <!-- <img v-else :src="image_url" width="100%" /> -->
      </v-card-title>
      <v-card
        flat
        color="transparent"
        width="100%"
        class="d-flex justify-center align-center my-3"
      >
        <v-card flat :color="wc_bg_title" width="100%" class="mx-4">
          <v-card-title
            :style="`color: ${wc_title}; font-size: 20px;word-break: break-word;`"
            :class="`justify-${wc_justify}`"
          >
            {{ surveyInfo.surveyName }}</v-card-title
          >
          <v-card-subtitle
            :style="`color: ${wc_subtitle};text-align: ${wc_justify};word-break: break-word;`"
            >{{ surveyInfo.surveyDetail }}
          </v-card-subtitle>
        </v-card>
      </v-card>
      <v-card-title class="pa-0">
        <v-form ref="form" class="px-4" style="width: 100%">
          <div class="d-flex justify-center">
            <v-btn
              :color="oneid.login_button.bg_color"
              :style="`color: ${oneid.login_button.text_color}`"
              :text="oneid.login_button.bt_texttype === 'text'"
              :outlined="oneid.login_button.bt_texttype === 'outlined'"
              :block="oneid.login_button.bt_block"
              :rounded="oneid.login_button.bt_rounded"
              @click="config ? false : LoginWithOneID()"
              style="font-size: 16px"
            >
              {{ oneid.login_button.text }}
            </v-btn>
          </div>

          <v-card-subtitle
            :class="`${oneid.showreg ? '' : 'py-2'}  text-center`"
            :style="`color: ${oneid.texttoreg_color};`"
            >{{ !oneid.showreg ? "" : oneid.texttoreg }}
          </v-card-subtitle>
          <div class="d-flex justify-center">
            <v-btn
              v-if="oneid.showreg"
              :color="oneid.reg_button.bg_color"
              :style="`color: ${oneid.reg_button.text_color}`"
              :text="oneid.reg_button.bt_texttype === 'text'"
              :outlined="oneid.reg_button.bt_texttype === 'outlined'"
              :block="oneid.reg_button.bt_block"
              :rounded="oneid.reg_button.bt_rounded"
              :href="config ? '' : 'https://one.th/register'"
              :target="config ? '' : '_blank'"
              style="font-size: 16px"
              >{{ oneid.reg_button.text }}</v-btn
            >
          </div>
        </v-form>
      </v-card-title>
    </v-card>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import jwtDecode from "jwt-decode";
export default {
  props: [
    "config",
    "surveyInfo",
    "image",
    "image_url",
    "image_size",
    "wc_color",
    "wc_bg_title",
    "wc_title",
    "wc_subtitle",
    "wc_justify",
    "wc_fullwidth",
    "oneid",
    "mobile_mode",
  ],
  mounted() {
    // console.log(this.oneid);
    if (this.oneid) {
      if (this.oneid.showreg_btn === undefined) {
        this.oneid.showreg_btn = true;
      }
      if (Object.keys(this.$route.query).includes("shared_token")) {
        if (this.$route.query.surveyID && this.$route.query.shared_token) {
          try {
            let jwtdata = jwtDecode(this.$route.query.shared_token);
            let data = {
              surveySession: "",
              surveyID: this.$route.query.surveyID,
              questionID: "start",
              answer: "",
              socialType: "webform",
              socialID: this.$route.query.surveyID,
              userID: "",
              username: "",
            };
            if (jwtdata.access_token) {
              try {
                let jwtdataonechat = jwtDecode(jwtdata.access_token);
                data = {
                  surveySession: "",
                  surveyID: this.$route.query.surveyID,
                  questionID: "start",
                  answer: "",
                  socialType: "webform",
                  socialID: this.$route.query.surveyID,
                  userID: jwtdataonechat.sub,
                  username: jwtdataonechat.username,
                };
                this.PassLogin(data, jwtdataonechat);
              } catch (error) {
                this.show = true;
                this.notimsg = "shared_token ไม่ถูกต้อง";
                this.snackbar = true;
              }
            } else {
              data = {
                surveySession: "",
                surveyID: this.$route.query.surveyID,
                questionID: "start",
                answer: "",
                socialType: "webform",
                socialID: this.$route.query.surveyID,
                userID: jwtdata.sub,
                username: jwtdata.username,
              };
              this.PassLogin(data, jwtdata);
            }
          } catch (error) {
            this.show = true;
            this.notimsg = "shared_token ไม่ถูกต้อง";
            this.snackbar = true;
          }
        } else {
          let textalert = "กรุณาส่งข้อมูลให้ครบถ้วน";
          if (!this.$route.query.surveyID) {
            textalert = textalert + " (ไม่พบ surveyID)";
            Swal.fire({
              html: textalert,
              text: "",
              icon: "error",
              showCancelButton: false,
              showConfirmButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              confirmButtonText: "ตกลง",
            });
          } else if (!this.$route.query.shared_token) {
            textalert = textalert + " (ไม่พบ shared_token)";
            this.show = true;
            this.notimsg = textalert;
            this.snackbar = true;
          }
        }
      } else {
        this.show = true;
      }
    }
  },
  data() {
    return {
      WImg: "100%",
      HImg: "auto",
      onechatlogin: process.env.VUE_APP_ONEID_LOGIN_WEBFORM,
      show: false,
      snackbar: false,
      notimsg: "",
      isOneTime: false,
      usernameOneID: '',
    };
  },
  computed: {
    TabletSize() {
      const { mdAndDown } = this.$vuetify.breakpoint;
      return mdAndDown;
    },
    // widthCard() {
    //   if (this.TabletSize || this.mobile_mode) {
    //     return "100%";
    //   } else {
    //     if (this.image) {
    //       if (this.image_size === "100%") {
    //         return "100%";
    //       } else {
    //         return this.image_size + "%";
    //       }
    //     } else {
    //       return "100%";
    //     }
    //   }
    // },
    widthCard() {
      if (this.TabletSize || this.mobile_mode) {
        return "100%";
      } else {
        return "100%";
      }
    },
  },
  methods: {
    LoginWithOneID() {
      this.$cookies.set(
        process.env.VUE_APP_COOKIE + "_LoginWithOneID_surveyID",
        this.$route.query.surveyID
      );
      window.location.href = this.onechatlogin;
    },
    PassLogin(data, jwtdata) {
      this.$store
        .dispatch("StartForm", data)
        .then((response) => {
          this.$store.commit("setFirstquestion", response.questionInfo);
          this.$cookies.set(
            process.env.VUE_APP_COOKIE + "_surveyInfo",
            response.surveyInfo
          );
          this.$cookies.set(
            process.env.VUE_APP_COOKIE +
              "_" +
              response.surveySession +
              "_questionStep",
            {
              qlist: [response.questionInfo.questionID],
            }
          );
          let param = {
            surveyID: this.$route.query.surveyID,
            surveySession: response.surveySession,
            username: jwtdata.username,
            userID: jwtdata.sub,
            questionID: response.questionInfo.questionID,
          };
          if (this.$route.query.shared_token) {
            param.shared_token = this.$route.query.shared_token;
          }
          if (this.$route.query.socialType) {
            param.socialType = this.$route.query.socialType;
          }
          if (this.$route.query.token) {
            param.token = this.$route.query.token;
          }
          if (this.$route.query.socialID) {
            param.socialID = this.$route.query.socialID;
          }
          this.$router.push({
            name: "webform",
            query: param,
          });
        })
        .catch((err) => {
          // console.log('err:',err);
          if (err.data.message === "surveyInfo not in Schedule Time") {
            Swal.fire({
              icon: "warning",
              text: "แบบสอบถามนี้ถูกเปลี่ยนให้สามารถทำได้ตามช่วงเวลาที่กำหนดเท่านั้น",
              title: "",
            }).then(() => {
              location.reload();
            });
          } else if (err.data.message === "surveyInfo status inactive") {
            Swal.fire({
              icon: "warning",
              text: "แบบสอบถามนี้ปิดรับคำตอบแล้ว",
              title: "",
            }).then(() => {
              location.reload();
            });
          } else if (
            err.data.message === "Dont have package or Package Expried"
          ) {
            Swal.fire({
              html: `แบบสอบถามนี้ไม่สามารถใช้งานได้ (Dont have package or Package Expried)<br>กรุณาติดต่อเจ้าของแบบสอบถาม`,
              icon: "warning",
              showCancelButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              confirmButtonColor: "#0093cc",
              confirmButtonText: "รับทราบ",
            });
          } else {
            if (
              err.data.message ===
              "surveySession is Duplicate can use survey in one time"
            ) {
              this.isOneTime = true
              this.usernameOneID = jwtdata.username
              this.$store.state.loading = false;
              this.show = true;
            } else {
              let text = "ไม่สามารถเริ่มทำแบบสอบถามได้";
              this.isOneTime = false
              this.$store.state.loading = false;
              this.show = true;
              this.notimsg = text;
              this.snackbar = true;
            }
          }
        });
    },
  },
};
</script>
